import { BasePostProvider } from "@tendercuts/http";
import { EndPoint } from "./base";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppState } from '@store/state';
import { LoginServices } from '@login';
import { ValidateCouponCode } from '../models';


@Injectable({ providedIn: "root" })
export class ValidateCouponService extends BasePostProvider<ValidateCouponCode> {
    constructor(public http: HttpClient, public endpointService: EndPoint, public loginService: LoginServices) {
        super(http);
    }

    get isCachable() {
        return false;
    }

    get isAuthenticatedEndpoint() {
        return true;
    }

    get authProtocol() {
        return this.loginService;
    }

    get model() {
        return ValidateCouponCode;
    }

    get endpoint() {
        return this.endpointService.validateCouponCode;
    }


    getParams(appState: AppState, couponCode) {
        const quote = appState.cartState.quote;
        const storeId = parseInt(appState.userState.user.store_id);
        const userParams = {
          id: quote.user.entityId,
          p: quote.user.phone,
          n: quote.user.firstname
        };
        const requestObject = {
          pay: quote.paymentMethod,
          p: [
            ...quote.cartProducts.map(item => {
              return { id: item.product.id, q: item.quantity };
            })
          ],
          u: userParams,
          s: storeId,
          c: couponCode,
          rp: quote.totals.rewardPointsSpend,
          v: '3.7.47'
        };
        return requestObject;
    }
}
